document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-tab-button]');
  if (!button) return;

  const root = button.closest('[data-tabs]');
  if (!root) return;

  const target = button.getAttribute('data-tab-button');

  root.querySelectorAll('[data-tab-button]').forEach((tabButton) => {
    const active = tabButton === button;
    tabButton.classList.toggle('is-active', active);
    tabButton.setAttribute('aria-selected', active ? 'true' : 'false');
  });

  root.querySelectorAll('[data-tab-panel]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
  });
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (!thumb) return;

  setActiveGalleryImage(thumb);
});

document.addEventListener('click', (event) => {
  const navButton = event.target.closest('[data-gallery-nav]');
  if (!navButton) return;

  const gallery = navButton.closest('.product-gallery');
  const direction = navButton.getAttribute('data-gallery-nav');
  moveGallery(gallery, direction);
});

function setActiveGalleryImage(thumb) {
  const gallery = thumb.closest('.product-gallery');
  if (!gallery) return;

  const mediaId = thumb.getAttribute('data-media-id');
  const mediaType = thumb.getAttribute('data-media-type') || 'image';

  if (!mediaId) {
    const mainImage = gallery.querySelector('[data-product-main-image]');
    const fullImage = thumb.getAttribute('data-full');
    const altText = thumb.getAttribute('data-alt') || '';

    if (mainImage && fullImage) {
      mainImage.src = fullImage;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.alt = altText;
    }
  }

  gallery.querySelectorAll('[data-gallery-media]').forEach((media) => {
    const active = media.getAttribute('data-gallery-media') === mediaId;
    media.classList.toggle('is-active', active);

    if (!active) {
      media.querySelectorAll('video').forEach((video) => video.pause());
    }
  });

  syncGalleryVideoPlayback(gallery);

  const expandButton = gallery.querySelector('[data-image-expand]');
  if (expandButton) expandButton.hidden = mediaType !== 'image';

  gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
    const active = item === thumb;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-current', active ? 'true' : 'false');
  });

  updateGalleryCounter(gallery);

  if (window.matchMedia('(max-width: 720px)').matches) {
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}

function moveGallery(gallery, direction) {
  if (!gallery) return;

  if (window.matchMedia('(max-width: 720px)').matches) {
    const slides = Array.from(gallery.querySelectorAll('[data-mobile-gallery-slide]'));
    if (!slides.length) return;

    const activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    const nextIndex = direction === 'prev'
      ? (activeIndex - 1 + slides.length) % slides.length
      : (activeIndex + 1) % slides.length;

    setActiveMobileGallerySlide(gallery, slides[nextIndex], true);
    return;
  }

  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  if (!thumbs.length) return;

  const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
  const nextIndex = direction === 'prev'
    ? (activeIndex - 1 + thumbs.length) % thumbs.length
    : (activeIndex + 1) % thumbs.length;

  setActiveGalleryImage(thumbs[nextIndex]);
}

function updateGalleryCounter(gallery) {
  if (!gallery) return;

  const current = gallery.querySelector('[data-gallery-current]');
  if (!current) return;

  const items = window.matchMedia('(max-width: 720px)').matches
    ? Array.from(gallery.querySelectorAll('[data-mobile-gallery-slide]'))
    : Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
  current.textContent = String(activeIndex + 1);
}

function setActiveMobileGallerySlide(gallery, slide, shouldScroll) {
  if (!gallery || !slide) return;

  gallery.querySelectorAll('[data-mobile-gallery-slide]').forEach((item) => {
    const active = item === slide;
    item.classList.toggle('is-active', active);

    if (!active) {
      item.querySelectorAll('video').forEach((video) => video.pause());
    }
  });

  syncGalleryVideoPlayback(gallery);

  updateGalleryCounter(gallery);

  if (shouldScroll) {
    slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
}

function syncGalleryVideoPlayback(gallery) {
  if (!gallery) return;

  const mobile = window.matchMedia('(max-width: 720px)').matches;
  const activeVideo = mobile
    ? gallery.querySelector('[data-mobile-gallery-slide].is-active video')
    : gallery.querySelector('[data-gallery-media].is-active video');

  gallery.querySelectorAll('video').forEach((video) => {
    if (video !== activeVideo) {
      video.pause();
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const playRequest = video.play();
    if (playRequest) playRequest.catch(() => {});
  });
}

document.querySelectorAll('.product-gallery.has-mobile-carousel').forEach((gallery) => {
  const track = gallery.querySelector('[data-mobile-gallery-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-mobile-gallery-slide]'));
  if (!track || !slides.length) return;

  let scrollTimer = 0;

  function syncGalleryFromScroll() {
    const trackRect = track.getBoundingClientRect();
    const trackCenter = trackRect.left + (trackRect.width / 2);
    let nearestSlide = slides[0];
    let nearestDistance = Infinity;

    slides.forEach((slide) => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + (slideRect.width / 2);
      const distance = Math.abs(trackCenter - slideCenter);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestSlide = slide;
      }
    });

    if (nearestSlide && !nearestSlide.classList.contains('is-active')) {
      setActiveMobileGallerySlide(gallery, nearestSlide, false);
    } else {
      updateGalleryCounter(gallery);
    }
  }

  track.addEventListener('scroll', () => {
    if (!window.matchMedia('(max-width: 720px)').matches) return;

    if (scrollTimer) window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(syncGalleryFromScroll, 90);
  }, { passive: true });

  updateGalleryCounter(gallery);
  syncGalleryVideoPlayback(gallery);
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    syncGalleryVideoPlayback(gallery);
  });
});

document.querySelectorAll('.product-hero-image').forEach((hero) => {
  let startX = 0;
  let startY = 0;

  hero.addEventListener('touchstart', (event) => {
    if (event.target.closest('video, iframe, model-viewer')) return;
    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
  }, { passive: true });

  hero.addEventListener('touchend', (event) => {
    if (event.target.closest('video, iframe, model-viewer')) return;
    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - startX;
    const deltaY = touch.clientY - startY;

    if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY)) return;

    const gallery = hero.closest('.product-gallery');
    moveGallery(gallery, deltaX < 0 ? 'next' : 'prev');
  }, { passive: true });
});

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-open-lightbox]');
  if (!openButton) return;

  const gallery = openButton.closest('.product-gallery');
  const lightbox = gallery.querySelector('[data-product-lightbox]');
  const mainImage = gallery.querySelector('.product-main-media.is-active [data-product-main-image], [data-product-main-image]');
  const lightboxImage = gallery.querySelector('[data-lightbox-image]');

  if (!lightbox || !mainImage || !lightboxImage) return;

  lightboxImage.src = mainImage.currentSrc || mainImage.src;
  lightboxImage.alt = mainImage.alt || 'Product image';
  lightbox.classList.add('is-open');
  lightbox.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('lightbox-open');
});

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-close-lightbox]');
  if (!closeButton) return;

  const lightbox = closeButton.closest('[data-product-lightbox]');
  if (!lightbox) return;

  lightbox.classList.remove('is-open');
  lightbox.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('lightbox-open');
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-product-lightbox].is-open').forEach((lightbox) => {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
  });
  document.documentElement.classList.remove('lightbox-open');
});

function cleanOverviewCopy(container) {
  const blockedHeadings = new Set(['condition', 'details', 'specifications', 'specs', 'important note']);
  const children = Array.from(container.children);
  let shouldRemove = false;

  children.forEach((child) => {
    const label = (child.textContent || '')
      .trim()
      .replace(/:$/, '')
      .replace(/\s+/g, ' ')
      .toLowerCase();
    const isHeadingTag = /^(H2|H3|H4|STRONG|B)$/i.test(child.tagName);
    const isParagraphHeading = /^P|DIV$/i.test(child.tagName) && blockedHeadings.has(label);
    const hasOnlyBlockedHeading = child.children.length === 1
      && /^(STRONG|B|SPAN|FONT)$/i.test(child.children[0].tagName)
      && blockedHeadings.has((child.children[0].textContent || '').trim().replace(/:$/, '').toLowerCase());
    const isBlockedHeading = (isHeadingTag || isParagraphHeading || hasOnlyBlockedHeading) && blockedHeadings.has(label);
    const isWaterNotice = label.includes('vintage watches are not water-tested') || label.includes('water resistance has not been tested');
    const isArchiveSoldRecord = /^recorded sold price:\s*\$[\d,]+(\.\d{2})?\s*on\s*\d{4}-\d{2}-\d{2}\.?$/i.test(label);
    const isHistoricalPhotoNote = label === 'please review all photos as part of the historical condition record.';
    const isDivider = /^[-–—⸻]+$/.test(label);

    if (isArchiveSoldRecord || isHistoricalPhotoNote) {
      child.remove();
      return;
    }

    if (isBlockedHeading || isWaterNotice || isDivider) {
      shouldRemove = true;
    }

    if (shouldRemove) {
      child.remove();
    }
  });
}

document.querySelectorAll('[data-clean-overview]').forEach(cleanOverviewCopy);

function setOneOfOneStatus(form, message) {
  let status = form.querySelector('[data-one-of-one-status]');
  if (!status) {
    status = document.createElement('p');
    status.className = 'product-cart-state';
    status.setAttribute('data-one-of-one-status', '');
    status.setAttribute('aria-live', 'polite');
    form.append(status);
  }

  status.textContent = message;
}

document.querySelectorAll('.one-of-one-form').forEach((form) => {
  const button = form.querySelector('[data-one-of-one-submit]');
  const variantInput = form.querySelector('[data-one-of-one-variant]');
  if (!button || !variantInput) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (button.dataset.submitting === 'true') return;

    const originalLabel = button.textContent.trim();
    const variantId = variantInput.value;
    button.dataset.submitting = 'true';
    button.disabled = true;
    button.textContent = 'Checking Cart…';

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(`Cart check failed with ${response.status}`);

      const cart = await response.json();
      const alreadyInCart = cart.items.some((item) => String(item.variant_id) === String(variantId));

      if (alreadyInCart) {
        button.textContent = 'Already in Cart';
        setOneOfOneStatus(form, 'This one-of-a-kind watch is already in your cart.');
        return;
      }

      button.textContent = 'Adding…';
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      button.disabled = false;
      button.dataset.submitting = 'false';
      button.textContent = originalLabel;
      setOneOfOneStatus(form, 'We could not verify your cart. Refresh the page and try again.');
    }
  });
});

const mobileSwapTimers = new WeakMap();

function resetMobileCardImageSwap(cardMedia) {
  const timer = mobileSwapTimers.get(cardMedia);
  if (timer) window.clearTimeout(timer);
  mobileSwapTimers.delete(cardMedia);
  cardMedia.classList.remove('is-alt-visible');
}

function initMobileCardImageSwap() {
  const cardMediaItems = Array.from(document.querySelectorAll('[data-card-image-swap], [data-image-swap]'));
  if (!cardMediaItems.length) return;

  cardMediaItems.forEach(resetMobileCardImageSwap);
}

initMobileCardImageSwap();

document.querySelectorAll('[data-feedback-scroll]').forEach((scroller) => {
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let isPaused = false;
  let resumeTimer = 0;
  let animationFrame = 0;
  let lastFrameTime = 0;
  let autoDirection = 1;
  const autoScrollSpeed = 14;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileFeedbackQuery = window.matchMedia('(max-width: 720px)');

  function getMaxScrollLeft() {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function pauseAutoScroll(delay = 1800) {
    isPaused = true;
    scroller.classList.remove('is-auto-scrolling');

    if (resumeTimer) window.clearTimeout(resumeTimer);
    if (delay === null) return;

    resumeTimer = window.setTimeout(() => {
      isPaused = false;
      lastFrameTime = 0;
    }, delay);
  }

  function autoScroll(timestamp) {
    animationFrame = window.requestAnimationFrame(autoScroll);

    const max = getMaxScrollLeft();
    if (reduceMotion || mobileFeedbackQuery.matches || max <= 0 || isPaused || isDragging) return;

    scroller.classList.add('is-auto-scrolling');

    if (!lastFrameTime) {
      lastFrameTime = timestamp;
      return;
    }

    const deltaSeconds = Math.min((timestamp - lastFrameTime) / 1000, .08);
    lastFrameTime = timestamp;

    const nextScrollLeft = scroller.scrollLeft + (autoScrollSpeed * deltaSeconds * autoDirection);

    if (nextScrollLeft >= max) {
      scroller.scrollLeft = max;
      autoDirection = -1;
      return;
    }

    if (nextScrollLeft <= 0) {
      scroller.scrollLeft = 0;
      autoDirection = 1;
      return;
    }

    scroller.scrollLeft = nextScrollLeft;
  }

  scroller.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || Math.abs(event.deltaY) < 2) return;

    pauseAutoScroll();

    const max = getMaxScrollLeft();
    if (max <= 0) return;

    const nextScrollLeft = Math.max(0, Math.min(max, scroller.scrollLeft + event.deltaY));
    if (nextScrollLeft === scroller.scrollLeft) return;

    event.preventDefault();
    scroller.scrollLeft = nextScrollLeft;
  }, { passive: false });

  scroller.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) return;

    pauseAutoScroll(2200);
    isDragging = true;
    startX = event.clientX;
    startScrollLeft = scroller.scrollLeft;
    scroller.classList.add('is-dragging');
    scroller.setPointerCapture(event.pointerId);
  });

  scroller.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    scroller.scrollLeft = startScrollLeft - (event.clientX - startX);
  });

  function stopDragging(event) {
    if (!isDragging) return;
    isDragging = false;
    scroller.classList.remove('is-dragging');

    if (event && scroller.hasPointerCapture(event.pointerId)) {
      scroller.releasePointerCapture(event.pointerId);
    }

    pauseAutoScroll(2200);
  }

  scroller.addEventListener('mouseenter', () => pauseAutoScroll(null));
  scroller.addEventListener('mouseleave', () => pauseAutoScroll(900));
  scroller.addEventListener('focusin', () => pauseAutoScroll(null));
  scroller.addEventListener('focusout', () => pauseAutoScroll(900));
  scroller.addEventListener('touchstart', () => pauseAutoScroll(2200), { passive: true });
  scroller.addEventListener('pointerup', stopDragging);
  scroller.addEventListener('pointercancel', stopDragging);
  scroller.addEventListener('pointerleave', stopDragging);

  if (!reduceMotion) {
    animationFrame = window.requestAnimationFrame(autoScroll);
  }
});

function initRelatedScrollDots() {
  document.querySelectorAll('.product-recommendations').forEach((section) => {
    const scroller = section.querySelector('.related-grid');
    const dots = Array.from(section.querySelectorAll('.related-scroll-dot'));
    if (!scroller || dots.length < 2) return;

    let frame = 0;

    function updateDots() {
      frame = 0;
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const progress = maxScroll ? scroller.scrollLeft / maxScroll : 0;
      const activeIndex = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    scroller.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(updateDots);
    }, { passive: true });

    window.addEventListener('resize', updateDots, { passive: true });
    updateDots();
  });
}

initRelatedScrollDots();
